import styled from "@emotion/styled";
import b11bg from "@/assets/images/cardBgWavesQuestions.png";

export const InnerWrapper = styled.div(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  gridColumn: "1/-1",
  paddingBlock: theme?.breakpoints?.sm ? 20 : 40,
}));

export const CardsWrapper = styled.div(({theme}) => ({
  display: "grid",
  gridGap: 20,
  gridTemplateColumns: theme?.breakpoints?.sm
    ? "repeat(1, 1fr)"
    : theme?.breakpoints?.xl
      ? "repeat(2, 1fr)"
      : "repeat(4, 1fr)",
  minHeight: 313,
  transition: "height 5s ease",
}));

export const Container = styled.div<{isCardOpen?: boolean}>(({theme, isCardOpen}) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  flexWrap: "wrap",
  width: theme?.breakpoints?.isMobile ? 336 : "100%",
  height: "auto",
  minHeight: 313,
  borderRadius: 16,
  boxShadow: "0px 0px 32px 0px #00000014",
  backgroundColor: isCardOpen ? "white" : "#E9EEF5",
  backgroundImage: isCardOpen ? "none" : `url(${b11bg})`,
  transition: "all 0.5s ease",
  ":hover": {
    boxShadow: "0px 0px 32px 0px rgba(0, 0, 0, 0.16)",
  },
}));

export const PlusIcon = styled.img<{isCardOpen?: boolean}>(({isCardOpen}) => ({
  position: "absolute",
  bottom: 20,
  right: 20,
  width: 32,
  height: 32,
  backgroundSize: 40,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  transition: "transform 0.5s",
  transform: isCardOpen ? "rotate(45deg)" : "rotate(0)",
}));

export const TextWrapper = styled.div(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme?.breakpoints?.md ? 20 : 25,
}));

export const TitleWrapper = styled.div(({theme}) => ({
  position: "relative",
  display: "flex",
  columnGap: 8,
  width: "fit-content",
  marginBottom: 12,
  ":after": {
    content: "''",
    position: "absolute",
    bottom: -4,
    left: 0,
    width: "70%",
    height: 2,
    backgroundColor: theme?.colors?.primaryBlue,
    WebkitClipPath: "polygon(0% 100%, 3% 0%, 100% 0%, 97% 100%)",
    clipPath: "polygon(0% 100%, 3% 0%, 100% 0%, 97% 100%)",
  },
}));

export const AnswerWrapper = styled.div<{maxHeightValue?: number; isCardOpen?: boolean}>(
  ({maxHeightValue, isCardOpen = false}) => ({
    maxHeight: isCardOpen ? maxHeightValue : 313,
    overflow: "hidden",
    transition: "max-height 0.3s ease",
  }),
);
